import React, { useEffect, useState } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../styles/fileBrowser.css';
import PropTypes from 'prop-types';
import { useGetImageCategoryIdMutation } from '../../../features/authentication/persistApiSlice';
import { 
  useDeleteImageMutation,
  useGetImageCategoriesMutation,
  useGetImagesMutation } from '../../../features/authentication/teacherDocumentApiSlice';
import SkeletonGrid from '../../../components/SkeletonLoader/SkeletonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ImageUploadSection from './ImageUploadMultiple';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import CustomToast from '../../../components/Toast';

const CustomCKFileBrowser = () => {
  const [categoryId, setCategoryId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState(null);
  const [allImages, setAllImages] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [getImageCategoryId] = useGetImageCategoryIdMutation();
  const [getImageCategories] = useGetImageCategoriesMutation();
  const [deleteImage] = useDeleteImageMutation();
  const [getImages, {isLoading}] = useGetImagesMutation();

  useEffect(() => {
    getCategoryIdAsync();
    getImageCategoriesAsync();
  }, []);

  useEffect(() => {
    if(categoryId && categories.length > 0){
      getImagesAsync();
    }
  }, [categoryId, categories]);
  
  const getCategoryIdAsync= async ()=>{
    const response = await getImageCategoryId();
    if(!response.error)
      setCategoryId(response.data.imageCategoryId);
  };

  const getImageCategoriesAsync= async ()=>{
    const response = await getImageCategories();
    if(!response.error)
      setCategories(response.data);
  };

  const getImagesAsync= async ()=>{
    const folderName = categories.find(item=> item.id == categoryId).folderName;
    const options = {
      categoryId: categoryId,
      folderName: folderName
    };
    const response = await getImages(options);
    if(!response.error){
      setAllImages(response.data);
      setImages(response.data);
    }
  };

  const selectImage = (url) => {
    const params = new URLSearchParams(window.location.search);
    const funcNum = params.get('CKEditorFuncNum');
      
    if (window.opener && funcNum) {
      window.opener.CKEDITOR.tools.callFunction(funcNum, url);
      window.close();
    }
  };

  const handleDelete = async (filename) => {
    const response = await deleteImage(encodeURIComponent(filename));
    if(!response.error){
      const updatedImages = images.filter(item=> item.filename != filename);
      setAllImages(updatedImages);
      setImages(updatedImages);
      CustomToast('Image deleted successfully.', 'success');
    }
  };

  const handleSearch = (searchText) =>{
    setSearchText(searchText);
    const searchImages = allImages.filter((item)=>item.filename.toLowerCase().includes(searchText.toLowerCase()));
    setImages(searchImages);
  };

  return (
    <>
      <h1 className='line mt-3 pb-3 pl-15'>Image Gallery</h1>
      <div className="row w-100">
        <div className="sidebar col-2">
          {categories.length == 0 ? (
            <SkeletonGrid
              rowCount={9}
              colCount={1}
              className='p-2 mt-4'
            />
          ):(
            <>
              <h5 className='mb-3'>Uploaded Images</h5>
              <div
                key={categories[0]?.id}
                className={`folder-item ${
                  categoryId === categories[0]?.id ? 'active' : ''
                }`}
                onClick={() => setCategoryId(categories[0]?.id)}
              >
                {categories[0]?.name}
              </div>
              <h5 className='mt-3'>Castle Images</h5>
              {categories
                .filter((folder) => folder.id != -1)
                .map((folder) => (
                  <div
                    key={folder.id}
                    className={`folder-item ${
                      categoryId === folder.id ? 'active' : ''
                    }`}
                    onClick={() => setCategoryId(folder.id)}
                  >
                    {folder.name}
                  </div>
                ))}
            </>
          )}
        </div>
        <div className="col">   
          {images == null ? (
            <>
              <div className='w-60'>
                <SkeletonGrid
                  rowCount={1}
                  colCount={4}
                  className='p-5 mt-2 rounded'
                />
              </div>
              <SkeletonGrid
                rowCount={1}
                colCount={1}
                className='p-3 mt-5'
              />
              <SkeletonGrid
                rowCount={3}
                colCount={6}
                className='p-5 mt-4 rounded'
              />
            </>
          ):(
            <>
              {categoryId == -1 &&
              <ImageUploadSection maxFiles={4} onSuccess = {getImagesAsync}/>
              }
              <div>
                <div className="custom-search position-relative mb-3">
                  <FontAwesomeIcon icon={faSearch} />
                  <input type="text" value={searchText} onChange={(e) => handleSearch(e.target.value)} className="form-control" />
                </div>
                <div className="image-grid">
                  {images?.length > 0 ? (
                    images.map((img, index) => (
                      <div
                        key={`img-${index}`}
                        className='cursor-pointer d-flex image-card justify-content-between'
                        onClick={() => selectImage(img.path)}
                      >
                        {categoryId == -1 && (
                          <button
                            className={`btn image-delete-btn position-absolute ${img.inUse ? 'disable-delete-btn' : 'active-delete-btn'} `}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(img.filename);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </button>
                        )}
                        <div className='align-items-center d-flex h-100 justify-content-center'>
                          <img src={img.path} alt={img.filename} />
                        </div>
                        <div className="file-name text-break" title={img.filename}>
                          {img.filename}
                        </div>
                      </div>
                    ))
                  ) : (
                    <>
                      {!isLoading && images != null &&
                      <p>No files in this folder</p>
                      }
                    </>
                  )}           
                </div>
              
              </div>
            </>
          )}
        </div>  
      </div>
    </>
  );
};

CustomCKFileBrowser.propTypes = {
  content: PropTypes.string,
  buttonText: PropTypes.string,
  handleButtonClick: PropTypes.func
};

export default CustomCKFileBrowser;
